import React from "react";

import Editor from './BEmbedCarouselEditor'
import EditorWrapper from '../../EditorWrapper'

import EmbedCarousel2 from "../../../redesign/components/EmbedCarousel2";
import EmptyArticle from "../../common/EmptyArticle";

const BEmbedCarousel = props => {
    let article = EmptyArticle();
    const { settings } = props;
    article.url = settings.url;

    if (settings.embed) {
        article.embed = settings.embed;
        article.embed.text = settings.text;
        article.embed.thumbnail = settings.thumbnail;
    }

    return (
        <div className={props.classes} {...props.events}>
            <EditorWrapper {...props} editor={Editor} />
            {/* <EmbedCarousel
                article={article}
                {...props}
            /> */}
            <EmbedCarousel2
                article={article}
                {...props}
            />
        </div>
    );
};


export default BEmbedCarousel;